import { Card, Typography } from '@mui/material';
import Iconify from '../Iconify';

export const AppWidgetSummary = ({ title, total, icon }) => {

    return (
        <Card sx={{ border: '1px solid #eceff1', borderRadius: 2, textAlign: 'center', boxShadow: 0, padding: '10px', bgcolor: "#eceff1" }}>
            <Iconify icon={icon} width={30} height={30} sx={{ color: '#CD5C5C' }} />
            <Typography variant="h3" sx={{ fontFamily: 'Mulish' }}>{total}</Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72, fontFamily: 'Mulish' }}>{title}</Typography>
        </Card>
    );
}